var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.156,
    height: 17.995,
    viewBox: "0 0 22.156 17.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.878,52.567c.014.2.014.394.014.59a12.831,12.831,0,0,1-12.92,12.92A12.832,12.832,0,0,1,0,64.038a9.393,9.393,0,0,0,1.1.056,9.094,9.094,0,0,0,5.637-1.94,4.549,4.549,0,0,1-4.246-3.149,5.726,5.726,0,0,0,.858.07,4.8,4.8,0,0,0,1.195-.155A4.541,4.541,0,0,1,.9,54.465v-.056a4.573,4.573,0,0,0,2.052.576,4.548,4.548,0,0,1-1.406-6.073,12.907,12.907,0,0,0,9.363,4.752,5.126,5.126,0,0,1-.112-1.04,4.545,4.545,0,0,1,7.859-3.107,8.94,8.94,0,0,0,2.882-1.1,4.529,4.529,0,0,1-2,2.5,9.1,9.1,0,0,0,2.615-.7A9.761,9.761,0,0,1,19.878,52.567Z",
    transform: "translate(0 -48.082)",
    fill: "#070b0e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a4609fd8e9a599e94e3ce83da9f1caf8.svg";
export { ForwardRef as ReactComponent };